// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/school_information.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schools_v1_resources_school } from "./school_pb.js";

/**
 * Describes the file studyo/today/schools/v1/resources/school_information.proto.
 */
export const file_studyo_today_schools_v1_resources_school_information = /*@__PURE__*/
  fileDesc("CjpzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvc2Nob29sX2luZm9ybWF0aW9uLnByb3RvEiFzdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMiwAEKEVNjaG9vbEluZm9ybWF0aW9uEjkKBnNjaG9vbBgBIAEoCzIpLnN0dWR5by50b2RheS5zY2hvb2xzLnYxLnJlc291cmNlcy5TY2hvb2wSFgoOb3duZXJfdXNlcl9pZHMYAiADKAkSGwoTaGFzX3N0dWRlbnRfYWNjb3VudBgDIAEoCBIbChNoYXNfdGVhY2hlcl9hY2NvdW50GAQgASgIEh4KFmFkbWluaXN0cmF0b3JfdXNlcl9pZHMYBSADKAlCKaoCJlN0dWR5by5Ub2RheS5TY2hvb2xzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_studyo_today_schools_v1_resources_school]);

/**
 * Describes the message studyo.today.schools.v1.resources.SchoolInformation.
 * Use `create(SchoolInformationSchema)` to create a new message.
 */
export const SchoolInformationSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_school_information, 0);

